<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->

                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">

                        <!--First Name-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">First Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="firstName" placeholder="Enter First Name" v-model="firstName">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{firstNameError}}</span>
                            </div>
                        </div>

                        <!--Last Name-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Last Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="lastName" placeholder="Enter Last Name" v-model="lastName">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{lastNameError}}</span>
                            </div>
                        </div>

                        <!--Email-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Email : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="email" placeholder="Enter Email" v-model="email">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{emailError}}</span>
                            </div>
                        </div>

                        <!--Dayforce ID-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">DayforceId: </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="dayforceId" placeholder="Enter DayforceId" v-model="dayforceId">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{dayforceIdError}}</span>
                            </div>
                        </div>

                        <!--Role-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Role :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="roleId"
                                          name="roleId"
                                          id="roleId"
                                          label="name"
                                          :filterable="true"
                                          :options="roleOptions"
                                          @input="onChnageRole()"
                                          placeholder="Select Role">
                                          <template slot="no-options">
                                        Search Location...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{roleError}}</span>
                            </div>
                        </div>

                        <!--Timezone-->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Timezone :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="timezoneId"
                                          name="timezoneId"
                                          id="timezoneId"
                                          label="text"
                                          :filterable="true"
                                          :options="timezoneOptions"
                                          @input="onChnageTimezone()"
                                          placeholder="Select Timezone">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{timezoneError}}</span>
                            </div>
                        </div> -->

                    </div>

                    <!--Permissions-->
                    <div class="row no-margin checkbox_container">
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Permissions :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <template v-for="(allPermission, index) in allPermissions">
                                    <input :value="allPermission.id" :key="allPermission.id" type="checkbox" name="permission[]"> {{allPermission.name}}<br>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="addUpdateUser ()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary" v-on:click.prevent="addUpdateUser (flag='Save and Continue')">
                        <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateUser ()"></input>-->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                    </div>

                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';

    var moment = require('moment-timezone');

    export default {
        name: 'AddUpdateUser',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Add User",

                firstName : '',
                firstNameError : "",
                lastName : '',
                lastNameError : "",
                email : "",
                emailError : "",
                dayforceId : "",
                dayforceIdError :"",

                allPermissions : [],
                checkedPermissions : [],

                roleOptions : [],
                roleError : "",
                selectedRole : "",
                roleId: {id: '0', name: 'Select Role'},

                timezoneOptions : [],
                timezoneError : "",
                selectTimezone : "",
                timezoneId : {
                    'text' : "",
                    'value' : "",
                },

                entityOptions : [],
                entityError : "",
                entityId : {
                    'text' : "",
                    'value' : "",
                },

                payPlanOptions : [],
                payPlanError : "",
                payPlanId : {
                    'text' : "",
                    'value' : "",
                },

                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                permissionRendered : false,

            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "listuser");
        },

        watch: {
            email : function (email) {
                if (email.length > 3) {
                    if (!self.validEmail(self.email)) {
                        self.emailError = 'Please Enter Valid Email';
                    } else {
                        self.checkUserInSSO();
                    }
                }
            },
            dayforceId: function (dayforceId) {
                if (dayforceId.length > 3) {
                    self.checkUserInSSO('dayforace');
                }
            },
        },
        mounted: function () {
            // EventBus.$emit('showHeader', true);
            $("#alertError").hide();
            self.getAllPermissions();

            /* Remove error on input */
            $("#firstName").keyup(function () {
                self.firstNameError = "";
            });

            $("#lastName").keyup(function () {
                self.lastNameError = "";
            });

            $("#email").keyup(function () {
                self.emailError = "";
            });

            $("#dayforceId").keyup(function () {
                self.dayforceIdError = "";
            });

            $("#timezoneId").keyup(function () {
                self.timezoneError = "";
            });


            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == 'update-user') {
                if (segments[2]) {
                    self.getUserDetailByUserId();
                    self.buttonNames.save = "Update";
                    $("#addAndContinueBenifitBtn").hide();
                    // $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit User";
                }
            }

            /* Get Id of checked Permissions  */
            $(document).ready(function() {
                $("#addBenifitBtn").click(function(){
                    var favorite = [];
                    $.each($("input[name='permission[]']:checked"), function(){
                        favorite.push($(this).val());
                    });
                    self.checkedPermissions = favorite ;
                });
            });
            self.getAllRoles();
            //self.getTimezone();
        },
        beforeDestroy(){
            // EventBus.$off('all-permissions');
        },
        methods: {
            getAllPermissionsss(){
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get("permission", config)
                    .then(function (data) {
                        //console.log('allPermissions', data)
                        if (data.status == 200) {
                            self.allPermissions = data.data;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            checkUserInSSO : function (flag) {
                let path = window.location.pathname;
                let segments = path.split('/');
                let updateFlag = false;
                let userId = 0;

                if (segments[1] === 'update-user') {
                    updateFlag = true;
                    userId = segments[2];
                } else {
                    updateFlag = false;
                }

                var data = {
                    emp_id : (flag == 'dayforace') ? self.dayforceId : self.email,
                    update_flag : updateFlag,
                    user_id : userId,
                }

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('user/checkinsso', data, config)
                    .then(function (response) {
                        // console.log('checkinsso', response)
                        if (response.status == 200) {
                            if(response.data.message && response.data.message != 'undefined'){
                                self.showSAlert(response.data.message,'success',false);
                            }
                        }
                    })
                    .catch(function (err) {
                        //console.log(err);
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            showAlertOnSave : function (alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack : function () {
                self.$router.push('/list-user');
            },

            onChangeEntity : function () {
                self.entityError = "";
            },

            onChangePayPlan : function () {
                self.payPlanError = "";
            },

            onChnageRole : function () {
                for (var i = 0; i < self.allPermissions.length; i++) {
                    if (self.roleId.value == 1) {
                        $("input[name='permission[]']").each(function (index, obj) {
                            if (obj.value == self.allPermissions[i].permission_id) {
                                $("input[value='" + obj.value + "']").prop('checked', true);
                            }
                        });
                    } else {
                        $("input[name='permission[]']").each(function (index, obj) {
                            if (obj.value == self.allPermissions[i].permission_id) {
                                $("input[value='" + obj.value + "']").prop('checked', false);
                            }
                        });
                    }
                }
                self.roleError = "";
            },

            clearDataOnSaveAndContinue : function () {
                self.name = '';
                self.checkedPermissions = [];
                self.firstName = "";
                self.lastName = "";
                self.email = "";
                self.roleId = {
                    'text' : "",
                    'value' : "",
                };
                self.entityId = {
                    'text' : "",
                    'value' : "",
                };
                self.payPlanId = {
                    'text' : "",
                    'value' : "",
                };
                /*self.loadLocations();
                self.loadStations();*/
                for (var i = 0; i < self.allPermissions.length; i++) {
                    $("input[name='permission[]']").each(function (index, obj) {
                        if (obj.value == self.allPermissions[i].permission_id) {
                            $("input[value='" + obj.value + "']").prop('checked', false);
                        }
                    });
                }
            },

            onChnageTimezone : function () {
                self.timezoneError = "";
            },

            getTimezone : function () {
                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };
                HTTP.get('get-timezone', config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.timezoneOptions = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },

            getAllRoles : function () {
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get('role', config)
                    .then(function (response) {
                        //console.log('roles', response)
                        if (response.status == '200') {
                            //alert('here');
                            self.roleOptions= response.data;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },


            checkForm: function () {
                var checked = true;
                if (!self.firstName) {
                    self.firstNameError = "First Name Required";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.lastName) {
                    self.lastNameError = "Last Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.roleId == null || !self.roleId.id || self.roleId.id == 0) {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.email && !self.validEmail(self.email)) {
                    self.emailError = "Please Enter Valid Email";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.dayforceId) {
                    self.dayforceIdError = "DayforceId Required";
                    if (checked) {
                        checked = false;
                    }
                }

                // if (self.timezoneId == null || !self.timezoneId.value) {
                //     self.timezoneError = "Timezone Required";
                //     if (checked) {
                //         checked = false;
                //     }
                // }

                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },


            getUserDetailByUserId: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    user_id: segments[2],
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/user/get-detail-by-user-id', fields, config).
                then(response => {

                    self.firstName = response.data.user.first_name;
                    self.lastName = response.data.user.last_name;
                    self.email = response.data.user.username;
                    self.dayforceId = response.data.user.emp_id;
                    if (response.data.user.roles[0] != null) {
                        self.roleId = {
                            'name' : response.data.user.roles[0].name,
                            'id' : response.data.user.roles[0].id,
                        };
                    }

                    self.$nextTick(() => {
                        if (response.data.user_permissions.length > 0) {
                            for (var i = 0; i < response.data.user_permissions.length; i++) {
                                self.checkedPermissions.push(response.data.user_permissions[i].id);
                                $("input[name='permission[]']").each(function (index, obj) {
                                    if (obj.value == response.data.user_permissions[i].id) {
                                        $("input[value='" + obj.value + "']").prop('checked', true);
                                    }
                                });
                            }
                        }
                    });

                })
                    .catch(function (err) {
                        // console.log(err);
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },

            addUpdateUser (flag) {
                setTimeout(() => {
                    self.checkForm();
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        // console.log('segments', segments);
                        var config = {
                            headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                        };

                        if (segments[1] == 'update-user') {
                            if (segments[2]) {
                                var data = {
                                    first_name: self.firstName,
                                    last_name: self.lastName,
                                    email: self.email,
                                    permission_id: self.checkedPermissions,
                                    role_id : self.roleId.id,
                                    entity_id : self.entityId.value,
                                    payplan_id : self.payPlanId.value,
                                    dayforce_id : self.dayforceId,
                                    timezone_id : self.timezoneId.value,
                                    id: segments[2],
                                };
                                self.buttonNames.save = "Updating ...";
                                self.disableButtons.save = true;
                                self.disableButtons.cancel = true;
                            } else {
                                if (flag == "Save and Continue") {
                                    self.buttonNames.saveAndContinue = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                } else {
                                    self.buttonNames.save = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                }
                            }
                        } else {
                            var data = {
                                first_name: self.firstName,
                                last_name: self.lastName,
                                email: self.email,
                                permission_id: self.checkedPermissions,
                                role_id : self.roleId.id,
                                entity_id : self.entityId.value,
                                payplan_id : self.payPlanId.value,
                                dayforce_id : self.dayforceId,
                                timezone_id : self.timezoneId.value,
                            };
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }

                        HTTP.post("/user/add", data, config)
                            .then(function (response) {
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if (segments[1] == 'update-user') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    if (segments[2]) {
                                        self.buttonNames.save = "Update";
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                        } else {
                                            self.buttonNames.save = "Save";
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                //console.log('user/add', response)
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.user_message);
                                    //self.showAlertOnSave(response.data.user_message, "success");
                                    self.showSAlert(response.data.user_message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            //self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                // console.log('update-error', err);
                                if (segments[1] == 'update-user') {
                                    if (segments[2]) {
                                        self.buttonNames = "Update";
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                            self.clearDataOnSaveAndContinue();
                                        } else {
                                            self.buttonNames.save = "Save";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/");
                                            }
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                            });
                    }
                }, 200);
            },
        }

    }

    EventBus.$on('all-permissions', function (isLogin, allPermissions) {
        if (typeof (self) != 'undefined') {
            self.allPermissions = [];
            for (var i = 0; i < allPermissions.length; i++) {
                var permissionNameArray = allPermissions[i].name.split("_");
                var permissionName = '';
                var permission = '';

                for (var j = 0; j < permissionNameArray.length; j++) {
                    permission = permissionNameArray[j].charAt(0).toUpperCase() + permissionNameArray[j].slice(1);
                    permissionName = permissionName +  " " + permission;
                }

                self.allPermissions.push({
                    'id' : allPermissions[i].id,
                    'name' : permissionName
                });
            }

            let path = window.location.pathname;
            let segments = path.split('/');

            if (segments[1] === 'update-user') {
                self.getUserDetailByUserId();
            }
            // self.allPermissions = allPermissions;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/User/AddUpdateUser.vue